import React, { useState, useEffect  } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from 'react-router-dom'
import * as UserActions from '../../../actions/UserActions'
import * as MyAPI from '../../../utils/MyAPI'
import Header from '../parts/Header'
import Footer from '../parts/Footer'
import { loginWithToken } from '../../../utils/Helper'
import Alert from 'react-s-alert';
import { Loader } from 'react-overlay-loader';
import 'react-overlay-loader/styles.css';
import { API_URL } from '../../../utils/Settings'
import {
  Container,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Input,
  Button,
  CustomInput,
  Label,
  FormGroup,
} from 'reactstrap';
import PaymentSubHeader from '../parts/PaymentSubHeader'
import * as AbstructedApi from '../../../utils/AbstructedApi'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  useStripe,
} from '@stripe/react-stripe-js';
import PaymentSubscriptionItem from './PaymentSubscriptionItem'

// PaymentTop
const PaymentTop = (props) => {

  const stripe = useStripe();

  // use history
  let navigate = useNavigate()

  // user_state
  let login_token = useSelector(state => {
    if (state.user && state.user.login_token) {
      return state.user.login_token
    } else {
      return ''
    }
  });

  let account_type = useSelector(state => {
    if (state.user && state.user.user_info && state.user && state.user.user_info.profile && state.user.user_info.profile.account_type) {
      return state.user.user_info.profile.account_type
    } else {
      return 'default'
    }
  });

  let user_state_createdAt = useSelector(state => {
    if (state.user && state.user.createdAt) {
      return state.user.createdAt
    } else {
      return ''
    }
  });

  let subscription_status = useSelector(state => {
    if (state.user && state.user.subscription_status) {
      return state.user.subscription_status
    } else {
      return 'unknown'
    }
  });

  let dispatch = useDispatch();

  // parameters
  let [loading, setLoading] = useState(false);
  let [usageTokenTotal, setUsageTokenTotal] = useState("");
  let [chargeAmount, setChargeAmount] = useState(0);
  let [subscriptions, setSubscriptions] = useState([])
  let [canceledSubscriptionsShowFlg, setCanceledSubscriptionsShowFlg] = useState(false)

  // componentDidMount
  useEffect(() => {

    if (!login_token) {
      // redirect
      navigate("/dashboard")
      return;
    }

    _firstScript()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // first script
  let _firstScript = async () => {

    // check subscription status
    if (subscription_status === "unknown") {
      let _obj = await AbstructedApi.checkSubscriptionStatus(login_token)
      dispatch(UserActions.setSubscriptionStatus({
        subscription_status: _obj.subscription_status,
      }))
    }

    // get current payment methods
    // await _getCurrentPaymentMethods(login_token)

    // get subscriptions
    await _getSubscriptions(login_token)
  }

  // _getSubscriptions
  let _getSubscriptions = async (_login_token) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.getSubscriptions({
        login_token: _login_token,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }

      if (results_1.list1) {
        setSubscriptions(results_1.list1)
      }

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }

  // // get current payment methods
  // let _getCurrentPaymentMethods = async (_login_token) => {
  //
  //   setLoading(true)
  //
  //   try {
  //
  //     console.log("_getCurrentPaymentMethods.1")
  //
  //     // get evaluation masters
  //     const results_1 = await MyAPI.getCurrentPaymentMethods({
  //       login_token: _login_token,
  //     })
  //     console.log("_getCurrentPaymentMethods.2")
  //
  //     if (results_1.status !== "success") {
  //       throw Error(results_1.message)
  //     }
  //     console.log("results_1: ", results_1)
  //
  //     // if (results_1.payment_method_id) {
  //     //   setPaymentMethodId(results_1.payment_method_id)
  //     // }
  //     //
  //     // if (results_1.payment_method_brand) {
  //     //   setPaymentMethodBrand(results_1.payment_method_brand)
  //     // }
  //     //
  //     // if (results_1.payment_method_exp_month) {
  //     //   setPaymentMethodExpMonth(results_1.payment_method_exp_month)
  //     // }
  //     //
  //     // if (results_1.payment_method_exp_year) {
  //     //   setPaymentMethodExpYear(results_1.payment_method_exp_year)
  //     // }
  //     //
  //     // if (results_1.payment_method_last4) {
  //     //   setPaymentMethodExpLast4(results_1.payment_method_last4)
  //     // }
  //
  //     // usage
  //     if (results_1.usage_token_total) {
  //
  //       let _hrs = 0
  //       let _usage_token_total = results_1.usage_token_total
  //       let _mins = _usage_token_total / 4
  //       if (_mins > 60) {
  //         _hrs = Math.floor(_mins / 60)
  //         _mins = _mins - _hrs * 60
  //       }
  //       let _str = ""
  //       if (_hrs) {
  //         _str = _hrs + " 時間 " + _mins + " 分"
  //       } else {
  //         _str = _mins + " 分"
  //       }
  //
  //       setUsageTokenTotal(_str)
  //     }
  //
  //     if (results_1.charge_amount) {
  //       setChargeAmount(results_1.charge_amount)
  //     }
  //
  //   } catch (err) {
  //     console.log("err: ", err )
  //
  //     Alert.error(err.message, {
  //       position: 'top-right',
  //       effect: 'slide',
  //       timeout: 5000
  //     });
  //
  //   }
  //
  //   setLoading(false)
  // }

  // _cancelSubscription
  let _cancelSubscription = async (item) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.cancelSubscription({
        login_token: login_token,
        subscription_id: item.subscription_id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }


      Alert.success("成功", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });


      let _obj = await AbstructedApi.checkSubscriptionStatus(login_token)
      dispatch(UserActions.setSubscriptionStatus({
        subscription_status: _obj.subscription_status,
      }))

      // get subscription
      _getSubscriptions(login_token)

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }

  // _updatePaymentMethod
  let _updatePaymentMethod = async (payment_method_id, subscription_id) => {

    setLoading(true)

    try {

      // get evaluation masters
      const results_1 = await MyAPI.updateSubscriptionPaymentMethod({
        login_token: login_token,
        subscription_id: subscription_id,
        payment_method_id: payment_method_id,
      })
      if (results_1.status !== "success") {
        throw Error(results_1.message)
      }


      Alert.success("成功", {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

      // get subscription
      _getSubscriptions(login_token)

    } catch (err) {
      console.log("err: ", err )

      Alert.error(err.message, {
        position: 'top-right',
        effect: 'slide',
        timeout: 5000
      });

    }

    setLoading(false)
  }

  //  toggle showing canceled subscriptions
  let _toggleCanceledSubscriptionsShow = () => {
    if ( canceledSubscriptionsShowFlg === true ) {
      setCanceledSubscriptionsShowFlg(false)
    } else {
      setCanceledSubscriptionsShowFlg(true)
    }
  }

  return (
    <div style={{
      backgroundColor: '#F2F5FA',
    }}>

      {/* header */}
      <Header />

      {/* sub header */}
      <PaymentSubHeader />

      <Container style={{
        minHeight: 400,
      }}>

        {/* invoice_client */}
        {account_type === "invoice_client" && (
          <Row style={{
            marginTop: 20,
            marginBottom: 0,
          }}>
            <Col md="12" xs="12">
              <span>
                請求書払いのお客様には現在オンライン明細は出ません。
                <br/>
                お手数ですが、営業までお問い合わせ頂けますでしょうか。
              </span>
            </Col>
          </Row>
        )}

        {/* toggle showing canceled subscriptions */}
        <Row style={{
          marginTop: 20,
          marginBottom: 0,
        }}>
          <Col md="3" xs="12" />

          <Col md="6" xs="12" style={{
            textAlign: 'right',
          }}>

            {subscriptions.length !== 0 && (
              <CustomInput
                label="キャンセル済みを表示"
                id={"toggle_show_cannceled_subscriptions"}
                onChange={_toggleCanceledSubscriptionsShow}
                type="switch"
                checked={canceledSubscriptionsShowFlg}
                name="toggle_show_cannceled_subscriptions" />
            )}

            {subscriptions.length === 0 && (
              <div style={{
                textAlign: 'left',
              }}>
                現在利用できるAPIキーがありません。
                <br/>
                <br/>
                APIキーは「サブスクリプションの追加」よりクレジットカードを登録して頂くことで発行できます。
                <br/>
                <br/>
              </div>
            )}



          </Col>
          <Col md="3" xs="12" />
        </Row>

        <Row style={{
          marginTop: 0,
          marginBottom: 20,
        }}>
          <Col md="3" xs="12" />

          <Col md="6" xs="12">

            {/* subscriptions */}
            {subscriptions.map((item) => (
              <PaymentSubscriptionItem
                showCanceled={canceledSubscriptionsShowFlg}
                setLoading={setLoading}
                updatePaymentMethod={_updatePaymentMethod}
                cancelSubscription={_cancelSubscription}
                key={item.subscription_id} item={item} />
            ))}

          </Col>
          <Col md="3" xs="12" />
        </Row>

      </Container>


      {/* footer */}
      <Footer />

      {/* loading */}
      <Loader fullPage={true} loading={loading} />

    </div>
  )
}

export default PaymentTop
